import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class ConNav extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pages: PropTypes.string,
    };

    render() {
        const {
            content: { introSubNav },
            pages,
        } = this.props;

        return (
            <div className={styles.subNav}>
                <ul>
                    {introSubNav.map((item, index) => {
                        return (
                            <li key={index}>
                                <a className={item.title === '大事记' && pages === 'news' ? 'cur' : ''} href={item.url}>
                                    {item.title}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default ConNav;
